/** SVG paths are `Element` but not `HTMLElement`; capture must still run so chrome on top does not steal the stream. */

export function setPointerCaptureIfSupported(target: EventTarget | null, pointerId: number): void {
  if (!(target instanceof Element) || typeof target.setPointerCapture !== 'function') return

  try {
    target.setPointerCapture(pointerId)
  } catch {
    /* element not connected, etc. */
  }
}

export function releasePointerCaptureIfHeld(target: EventTarget | null, pointerId: number): void {
  if (!(target instanceof Element) || typeof target.releasePointerCapture !== 'function') return
  if (!target.hasPointerCapture(pointerId)) return

  try {
    target.releasePointerCapture(pointerId)
  } catch {
    /* ignore */
  }
}
